import { Component, ElementRef, inject, input, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { HisUploadFile } from '../../model/his-upload-file';
import { HisFileUploadService } from '../../service/his-file-upload.service';

@Component( {
    selector: 'his-upload-file-download',
    templateUrl: './his-upload-file-download.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisUploadFileDownloadComponent {
    private fileUploadService = inject(HisFileUploadService);

    value = input.required<HisUploadFile>();
    disabled = input<boolean>( false );

    /** The rendered download button, absent while the component is disabled. */
    readonly button = viewChild<ElementRef<HTMLButtonElement>>( 'button' );

    protected downloadFile( event: UIEvent ): void {
        event.preventDefault();

        if ( this.disabled() ) {
            return;
        }

        const link = document.createElement( 'a' );
        link.href = this.value().downloadUrl || this.fileUploadService.getDownloadUrl( this.value() );
        link.target = '_blank';
        link.download = this.value().name;
        link.click();
    }
}
